import { useAppStore, useTokensStore } from '@/src/store/global';
import { convertMillisToTime, hexToStr, toJson } from '@/src/lib/MayzSmartDB';
import React, { Fragment } from 'react';
import styles from './ShowTokensStore.module.scss';

interface IShowTokensStoreProps {}

const ShowTokensStore: React.FC<IShowTokensStoreProps> = (props?: IShowTokensStoreProps) => {
    const tokensStore = useTokensStore();
    const appStore = useAppStore();

    return tokensStore !== undefined && appStore.siteSettings?.debug === true ? (
        <Fragment>
            <table className={styles.tableForm}>
                <tbody>
                    <tr>
                        <td>
                            <div className={styles.debug}>
                                <h2 className={styles.title}>DEBUG MODULE</h2>
                                <div className={styles.info}>
                                    <div className={styles.title}>Servert Time: </div>
                                    <div className={styles.desc}>{convertMillisToTime(tokensStore.serverTime ?? 0)}</div>
                                </div>

                                <div className={styles.info}>
                                    <div className={styles.title}>tokens With Details And Validity</div>
                                    {tokensStore.tokensWithDetailsAndValidity.map((token, index) => (
                                        <div
                                            className={styles.desc}
                                            key={index}
                                            dangerouslySetInnerHTML={{
                                                __html: toJson(
                                                    {
                                                        // CS: formatHash(token.CS),
                                                        TN_Str: hexToStr(token.TN_Hex),
                                                        ticker: token.ticker,
                                                        priceADAx1e6: token.priceADAx1e6,
                                                        validity: token.validity,
                                                        followUp: token.followUp,
                                                    },
                                                    4
                                                ),
                                            }}
                                        />
                                    ))}
                                </div>
                                <div className={styles.info}>
                                    <div className={styles.title}>tokens With Details</div>
                                    {tokensStore.tokensWithDetails.map((token, index) => (
                                        <div
                                            className={styles.desc}
                                            key={index}
                                            dangerouslySetInnerHTML={{
                                                __html: toJson(
                                                    {
                                                        // CS: formatHash(token.CS),
                                                        TN_Str: hexToStr(token.TN_Hex),
                                                        ticker: token.ticker,
                                                        priceADAx1e6: token.priceADAx1e6,
                                                        date: token.date,
                                                        decimals: token.decimals,
                                                        isFT: token.isFT,
                                                        tokensInFT: token.tokensInFT.map((t) => hexToStr(t.TN_Hex)),
                                                        followUp: token.followUp,
                                                        keepAlive: token.keepAlive,
                                                        image: token.image ?? 'NO',
                                                        raw: token.metadata_raw ?? 'NO',
                                                    },
                                                    4
                                                ),
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <br />
        </Fragment>
    ) : null;
};

export default ShowTokensStore;
